import {Component, EnvironmentInjector, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {UnikoServiceTypes} from 'src/app/services/payments-api.service';
import {localizeRoute} from '../../utilities/localizeRoutes';
import { CommonModule } from "@angular/common";
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-service-card',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslocoPipe],
  templateUrl: './service-card.component.html',
  styleUrl: './service-card.component.css'
})
export class ServiceCardComponent implements OnInit{

  @Input() title = '';
  @Input() subtitle = '';
  @Input() imagePath = '';
  @Input() ctaTitle = '';
  @Input() ctaLink = '';
  @Input() propertyCode = '';
  @Input() serviceType: UnikoServiceTypes = UnikoServiceTypes.undefined;
  @Input() isServicePage: boolean = true;
  @Input() isAuctioned: boolean = false;
  @Input() comingSoon: boolean = false;
  @Input() isSold: boolean = false;
  @Output() navigate: EventEmitter<string> = new EventEmitter();

  public localizedRoute = localizeRoute;
  public serviceTypeString: string | undefined = undefined;

  protected disableButton = false

  constructor(
    private _router: Router,
    @Inject(EnvironmentInjector) public envInjector: EnvironmentInjector,
  ) {
  }
  ngOnInit(): void {
    this.disableButton = this.isAuctioned || this.isSold;
    this.serviceTypeString = UnikoServiceTypes[this.serviceType];
  }


  protected goServiceDetailsPage() {
    const serviceTypeString = UnikoServiceTypes[this.serviceType];

    if (this.serviceType && this.isServicePage) {

      this.navigate.emit(serviceTypeString);
      return;
    }
    if (serviceTypeString !== 'undefined') {
      this._router.navigate([localizeRoute(`/services/${serviceTypeString}`, this.envInjector)], {
        queryParams: {
          property: this.propertyCode
        },
        queryParamsHandling: 'merge',
      });
    }
  }

}
